import { HttpClient } from '@opallabs/api'
import { loadJsonApiEntities } from '../loadJsonApiEntities'

const fetchPresentations = () => HttpClient().get('/api/v1/presentations')

const getPresentations = () => (dispatch) =>
  fetchPresentations()
    .then((response) => dispatch(loadJsonApiEntities(response.data)))
    .catch((err) => {
      console.log(err)
      throw err
    })

export default getPresentations
